"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.createFFmpegForEnv = void 0;
exports.getH5JAttrs = getH5JAttrs;
exports.openH5J = openH5J;
exports.readH5JChannelUint16 = readH5JChannelUint16;
exports.readH5JChannelUint8 = readH5JChannelUint8;

var hdf5 = _interopRequireWildcard(require("jsfive/dist"));

var _ffmpeg = require("@ffmpeg/ffmpeg");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

// The `src` can be either a `File` or a string specifying a URL.
function openH5J(_x) {
  return _openH5J.apply(this, arguments);
}

function _openH5J() {
  _openH5J = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2(src) {
    var errPrefix;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            errPrefix = "openH5J failed:"; // Treat a string argument as a URL and use `fetch` to return a promise that 
            // resolves to the H5J file.

            if (!(typeof src === 'string')) {
              _context2.next = 3;
              break;
            }

            return _context2.abrupt("return", fetch(src).then(function (response) {
              if (response.ok) {
                if (response.status === 200) {
                  return response.arrayBuffer();
                }

                throw new Error("".concat(errPrefix, " response.status ").concat(response.status, ", \"").concat(response.statusText, "\""));
              }

              throw new Error("".concat(errPrefix, " response.ok false"));
            }).then(function (buffer) {
              var fileHdf5 = new hdf5.File(buffer);
              return fileHdf5;
            }));

          case 3:
            if (!(src instanceof global.File)) {
              _context2.next = 5;
              break;
            }

            return _context2.abrupt("return", new Promise(function (resolve, reject) {
              var reader = new FileReader();

              reader.onload = function () {
                try {
                  var fileHdf5 = new hdf5.File(reader.result, src.name);
                  resolve(fileHdf5);
                } catch (exc) {
                  reject(new Error("".concat(errPrefix, " ").concat(exc)));
                }
              };

              reader.onerror = reject;
              reader.readAsArrayBuffer(src);
            }));

          case 5:
            return _context2.abrupt("return", Promise.reject(new Error("".concat(errPrefix, " unknown \"src\" type"))));

          case 6:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  }));
  return _openH5J.apply(this, arguments);
}

function getH5JAttrs(fileH5J) {
  if (!fileH5J) {
    return null;
  }

  var attrs = fileH5J.attrs;

  var result = _objectSpread({}, attrs);

  var channelsGroup = fileH5J.get('Channels');

  if (channelsGroup) {
    var channels = _objectSpread({}, channelsGroup.attrs);

    channels.names = channelsGroup.keys.map(function (channelName) {
      return channelName;
    });
    channels.content_types = channelsGroup.keys.map(function (channelName) {
      return channelsGroup.get(channelName).attrs.content_type;
    });
    result.channels = channels;
  }

  return result;
}

var createFFmpegForEnv = /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var t0, ff, t1;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            t0 = performance.now();

            if (process.env.NODE_ENV === 'development') {
              ff = (0, _ffmpeg.createFFmpeg)({
                // The `corePath` is necessary because otherwise, the `create-react-app`
                // dev server does not serve some "core" ffmpeg.wasm files correctly:
                // https://github.com/ffmpegwasm/ffmpeg.wasm#why-it-doesnt-work-in-my-local-environment
                // "When calling ffmpeg.load(), by default it looks for 
                // http://localhost:3000/node_modules/@ffmpeg/core/dist/ 
                // to download essential files (ffmpeg-core.js, ffmpeg-core.wasm, ffmpeg-core.worker.js). 
                // It is necessary to make sure you have those files served there.
                // Use the public address [i.e., unpkg.com] if you don't want to host your own."
                // The problem may have been introduced between ffmpeg.wasm v0.10.0 and v0.10.1:
                // https://github.com/ffmpegwasm/ffmpeg.wasm/issues/199#issuecomment-871165126
                // Note that the `core@` version number must match what is in `package.json`.
                corePath: 'https://unpkg.com/@ffmpeg/core@0.10.0/dist/ffmpeg-core.js',
                log: true
              });
            } else {
              ff = (0, _ffmpeg.createFFmpeg)({
                log: true
              });
            }

            _context.next = 4;
            return ff.load();

          case 4:
            t1 = performance.now();
            console.log("Initializing ffmpeg.wasm took ".concat(Math.round(t1 - t0), " ms"));
            return _context.abrupt("return", ff);

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function createFFmpegForEnv() {
    return _ref.apply(this, arguments);
  };
}();

exports.createFFmpegForEnv = createFFmpegForEnv;

function readH5JChannel(_x2, _x3, _x4, _x5, _x6) {
  return _readH5JChannel.apply(this, arguments);
} // Returns a new `Uint8Array` with the H5J data from the specified channel.  Several of the
// original 12-bit data values will be mapped to each 8-bit result value.  For original data
// value `d`, the result value is roughly the rounded value `Math.floor(d/16 + 0.5)`, but
// there are slight variations: see the accuracy test in `web-h5j-loader.test.js` for details.
// The `ffmpeg0` argument can be omitted, and initialization of ffmpeg.wasm will
// happen automatically.  But it will be done with again for each file to be read.
// To improve performance, explicitly call `await createFFmpegForEnv()` once and
// pass the result as the `ffmpeg0` argument with each file to be read.
// TODO: Support a channel index argument as an alternative to `channelName`.


function _readH5JChannel() {
  _readH5JChannel = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3(channelName, fileH5J, onProgress0, ffmpeg0, pixFmt) {
    var ffmpeg, onProgress, channelH5J, inputFileName, outputFileName, data;
    return regeneratorRuntime.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            if (fileH5J) {
              _context3.next = 2;
              break;
            }

            return _context3.abrupt("return", null);

          case 2:
            ffmpeg = ffmpeg0;

            if (ffmpeg) {
              _context3.next = 7;
              break;
            }

            _context3.next = 6;
            return createFFmpegForEnv();

          case 6:
            ffmpeg = _context3.sent;

          case 7:
            onProgress = onProgress0;

            if (!onProgress) {
              onProgress = function onProgress(_ref2) {
                var ratio = _ref2.ratio;
                console.log("Loaded ".concat(ratio * 100, "%"));
              };
            }

            ffmpeg.setProgress(onProgress);
            _context3.prev = 10;
            channelH5J = fileH5J.get("Channels/".concat(channelName));
            _context3.next = 18;
            break;

          case 14:
            _context3.prev = 14;
            _context3.t0 = _context3["catch"](10);
            console.log("Cannot get H5J channel ".concat(channelName, ": '").concat(_context3.t0, "'"));
            return _context3.abrupt("return", null);

          case 18:
            _context3.prev = 18;
            inputFileName = "".concat(fileH5J.filename, "_").concat(channelName);
            outputFileName = "".concat(inputFileName, ".raw"); // Use the ffmpeg.wasm commands to fetch the data from the channel of the HDF5 container
            // and write it to a "file" with a name from  `inputFileName` on the internal "file system" (as
            // implemented by Emscripten: https://emscripten.org/docs/porting/files/file_systems_overview.html)

            _context3.t1 = ffmpeg;
            _context3.t2 = inputFileName;
            _context3.next = 25;
            return (0, _ffmpeg.fetchFile)(channelH5J.value);

          case 25:
            _context3.t3 = _context3.sent;

            _context3.t1.FS.call(_context3.t1, 'writeFile', _context3.t2, _context3.t3);

            _context3.next = 29;
            return ffmpeg.run('-i', inputFileName, '-c:v', 'rawvideo', '-pix_fmt', pixFmt, '-f', 'rawvideo', outputFileName);

          case 29:
            // Use a ffmpeg.wasm command to read the data from the "file" named `volume.raw` and return it
            // as a JavaScript `Uint8Array` typed array ("array-like objects that provide a mechanism for
            // reading and writing raw binary data in memory buffers").
            data = ffmpeg.FS('readFile', outputFileName);
            return _context3.abrupt("return", data);

          case 33:
            _context3.prev = 33;
            _context3.t4 = _context3["catch"](18);
            console.log("Cannot use ffmpeg.wasm to decode channel ".concat(channelName, ": '").concat(_context3.t4, "'"));
            return _context3.abrupt("return", null);

          case 37:
          case "end":
            return _context3.stop();
        }
      }
    }, _callee3, null, [[10, 14], [18, 33]]);
  }));
  return _readH5JChannel.apply(this, arguments);
}

function readH5JChannelUint8(_x7, _x8, _x9, _x10) {
  return _readH5JChannelUint.apply(this, arguments);
} // Returns a new `Uint16Array` with the H5J data from the specified channel.  The data values
// will be roughly the original 12-bit values (i.e., they will NOT be scaled, so  an original
// value of 2^12 - 1 will NOT become 2^16 - 1) but there are slight variations: see the accuracy
// test in `web-h5j-loader.test.js` for details.
// See the comment on `readH5JChannelUint8` discussing the `ffmpeg0` argument.


function _readH5JChannelUint() {
  _readH5JChannelUint = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee4(channelName, fileH5J, onProgress0, ffmpeg0) {
    return regeneratorRuntime.wrap(function _callee4$(_context4) {
      while (1) {
        switch (_context4.prev = _context4.next) {
          case 0:
            return _context4.abrupt("return", readH5JChannel(channelName, fileH5J, onProgress0, ffmpeg0, 'gray'));

          case 1:
          case "end":
            return _context4.stop();
        }
      }
    }, _callee4);
  }));
  return _readH5JChannelUint.apply(this, arguments);
}

function readH5JChannelUint16(_x11, _x12, _x13, _x14) {
  return _readH5JChannelUint2.apply(this, arguments);
}

function _readH5JChannelUint2() {
  _readH5JChannelUint2 = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee5(channelName, fileH5J, onProgress0, ffmpeg0) {
    var dataUint8, dataUint16;
    return regeneratorRuntime.wrap(function _callee5$(_context5) {
      while (1) {
        switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return readH5JChannel(channelName, fileH5J, onProgress0, ffmpeg0, 'gray12le');

          case 2:
            dataUint8 = _context5.sent;
            dataUint16 = new Uint16Array(dataUint8.buffer);
            return _context5.abrupt("return", dataUint16);

          case 5:
          case "end":
            return _context5.stop();
        }
      }
    }, _callee5);
  }));
  return _readH5JChannelUint2.apply(this, arguments);
}